import { isTrackingHost } from '@/plugins/google-analytics';

export function trackEvent(eventName, params = {}) {
  if (!isTrackingHost) return;
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }
    // Fallback: push to dataLayer if available
    if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...params });
    }
  } catch {
    // Silently ignore analytics errors
    // console.debug('GA trackEvent error', e)
  }
}
